var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "polygon-overlay",
    class: {
      'polygon-overlay--filtered': _vm.filtered
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 3190 1960",
      "height": "98rem",
      "width": "159.5rem",
      "fill": _vm.polygon.fill,
      "stroke": _vm.polygon.stroke,
      "stroke-width": _vm.polygon.strokeWidth
    }
  }, [_c('polygon', {
    class: {
      'drop-shadow': _vm.polygon.dropShadow
    },
    attrs: {
      "points": _vm.pointToPolygon
    },
    on: {
      "click": function click($event) {
        return _vm.navigationTo($event);
      }
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }